import { hasAnyPendingDrafts } from "lib/@offline/local-draft-store"
import { confirm } from "lib/@dialogs/confirm"

/**
 * Check for pending local drafts and prompt the user before logging out.
 * @returns {Promise<boolean>} true if logout should proceed, false if cancelled
 */
export async function guardLogout() {
    if (await hasAnyPendingDrafts()) {
        return confirm(
            "You have unsaved changes that haven't been synced to the server yet. Logging out will discard them.",
            "Discard unsaved changes?"
        )
    }
    return true
}
